"use strict";
exports.__esModule = true;
exports.getInitials = void 0;
var getInitials = function (fullName) {
    if (fullName && fullName.length > 0) {
        var namePartsArray = fullName.trim().split(' ');
        var firstInitial = '';
        var lastInitial = '';
        if (namePartsArray.length > 0) {
            var firstName = namePartsArray[0];
            if (firstName.length > 0) {
                firstInitial = firstName[0];
            }
            if (namePartsArray.length > 1) {
                var lastPart = namePartsArray[namePartsArray.length - 1];
                if (lastPart.length > 0) {
                    lastInitial = lastPart[0];
                }
            }
        }
        var initials = "".concat(firstInitial).concat(lastInitial);
        return initials.toUpperCase();
    }
    return '?';
};
exports.getInitials = getInitials;
